import { combineReducers } from "@reduxjs/toolkit";

import { authSlide } from "@/modules/auth/store/authSlice";
import { registerSlice } from "@/modules/auth/store/registerSlice";
import { dispersionsSlice } from "@/modules/dashboard/dispersions/store/dispersionsSlice";
import { notificationsSlice } from "@/modules/dashboard/notifications/store/notificationsSlice";
import { swapsSlice } from "@/modules/dashboard/swaps/store/swapsSlice";

export const rootReducer = combineReducers({
  auth: authSlide.reducer,
  register: registerSlice.reducer,
  dispersions: dispersionsSlice.reducer,
  swaps: swapsSlice.reducer,
  notifications: notificationsSlice.reducer,
});
